<template>
    <div 
        class="o-mobile-map-modal-inner-granby"
        :style="commonStyles"
    >
        <img 
            :src="icon" 
            class="background"
            v-if="icon"
        >
        <img 
            src="../../../assets/images/mobilkarta_popup.svg" 
            class="background"
            v-else
        >
        <OQrCodeGenerator
            :useLang="true"
            class="generated-qr"
        />
        <!-- <img src="../../../assets/images/mobile-map-logo-granby.svg" class="granby-logo">
        <div class="qr-block">
            <span class="title">
                {{ $t('ui.scan-qr-get-map') }}
            </span>
            <div class="qr-container-granby">
                <img src="../../../assets/images/scan-qr-granby.svg" >
                <OQrCodeGenerator
                    :useLang="true"
                    class="generated-qr"
                />
            </div>
        </div>
        <div class="image-block">
            <img src="../../../assets/images/mobile-map-granby.png">
        </div> -->
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import OQrCodeGenerator from '../../organisms/o-qr-code-generator/o-qr-code-generator';

export default {
    name: 'OMobileMapModalInnerGranby',
    components: {
        OQrCodeGenerator
    },
    computed: {
        ...mapState({
            activeLocale: state => state.activeLocale
        }),
        ...mapGetters([
            'getMapConfigProp'
        ]),
        commonStyles() {
            return this.getMapConfigProp('components.OMobileMapModalInner.styles', {});
        },
        commonParams() {
            return this.getMapConfigProp('components.OMobileMapModalInner.params', {});
        },
        icon() {
            return this.commonParams[`icon_${this.activeLocale}`]
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />